import { getTransactionFilterTypeChipsMapping } from "./transactionFilterTypeChipConfig.js";
import { getTransactionStatusWithReasonChipConfig } from "./transactionStatusWithReasonChipConfig.js";
import { localizedAccountVerificationStatus } from "../../intl/shared-resources/accountVerificationStatus.js";
import { localizedAccountVerificationType } from "../../intl/shared-resources/accountVerificationType.js";
import { localizedAmlLabel } from "../../intl/shared-resources/amlLabel.js";
import { localizedBackpackStatus } from "../../intl/shared-resources/backpackStatus.js";
import { localizedPlayerBonusStatus } from "../../intl/shared-resources/bonusStatus.js";
import { localizedBulkStatus } from "../../intl/shared-resources/bulkStatus.js";
import { localizedConnectionType } from "../../intl/shared-resources/connectionType.js";
import { localizedFeatureAccessStatus } from "../../intl/shared-resources/featureAccessStatus.js";
import { localizedGender } from "../../intl/shared-resources/gender.js";
import { localizedKycStatus } from "../../intl/shared-resources/kycStatus.js";
import { localizedLoginStatus } from "../../intl/shared-resources/loginStatus.js";
import { localizedPaymentOption } from "../../intl/shared-resources/paymentOption.js";
import { localizedPlayersRelationType } from "../../intl/shared-resources/playersRelationType.js";
import { localizedSecuritySettings } from "../../intl/shared-resources/securitySettings.js";
import { localizedUserAccountStatus } from "../../intl/shared-resources/userAccountStatus.js";
import { localizedUserStatisticsGameType } from "../../intl/shared-resources/userStatisticsGameType.js";
import { BulkStatus } from "../../models/bulk-operation/types.js";
import { ChipType, ChipVariant } from "../../components/chip/types.js";
import "../../components/icons/Icon.js";
import "react";
import { CustomIcon } from "../../components/icons/types.js";
import "../../components/icons/ExpandMoreIcon.js";
import { TicketStatusTypeName, GamePlatformTypeName, GeoCheckEventSourceTypeName, GeoCheckStatusTypeName, RevenueShareOfferingStatusTypeName, WorkspaceTypeName, NoteTypeTypeName, FeatureAccessStatusTypeName, BulkStatusTypeName, AccountVerificationTypeTypeName, PaymentVendorTypeName, PaymentOptionTypeName, UserStatisticsGameTypeTypeName, PlayersRelationTypeTypeName, KycStatusTypeName, LoginStatusTypeName, EnablementModeTypeName, GenderTypeName, AccountVerificationStatusTypeName, ConnectionTypeTypeName, AmlLabelTypeName } from "../../contract/constants.js";
import { FeatureAccessStatus, BackpackItemStatus, PlayerBonusStatus, AccountVerificationType, PaymentVendor, PaymentOption, UserStatisticsGameType, PlayersRelationType, KycStatus, LoginStatus, Gender, AccountVerificationStatus, AmlLabel, UserAccountStatus } from "../../contract/pam.js";
import { BackpackItemStatusTypeName } from "../../features/backpack/constants.js";
import { PlayerBonusStatusTypeName } from "../../features/player-bonus/constants.js";
import { TransactionStatusWithReasonTypeName, TransactionFilterTypeTypeName, TransactionTypeTypeName, TransactionStatusTypeName } from "../../features/transaction/constants.js";
import { ChannelTypeName, UserAccountStatusTypeName } from "../../features/user-profile/constants.js";
import { ConnectionType } from "../connectionType.js";
import { EnablementMode } from "../enablementMode.js";
import { getBulkAccountVerificationStatusChipsMapping } from "./bulkAccountVerificationStatusConfig.js";
import { getChannelChipsMapping } from "./channelConfig.js";
import { getGamePlatformChipsMapping } from "./gamePlatformChipConfig.js";
import { getGeoCheckEventSourceChipsMapping } from "./geoCheckEventSourceChipConfig.js";
import { getGeoCheckStatusChipsMapping } from "./geoCheckStatusChipConfig.js";
import { getNoteTypeChipsMapping } from "./noteTypeChipsConfig.js";
import { getRevenueShareOfferingStatusChipsMapping } from "./revenueShareOfferingStatusChipConfig.js";
import { getTicketStatusChipMapping } from "./ticketStatusChipConfig.js";
import { getTransactionStatusChipsMapping } from "./transactionStatusChipConfig.js";
import { getTransactionTypeChipsMapping } from "./transactionTypeChipConfig.js";
import { getWorkspaceChipsMapping } from "./workspaceChipsConfig.js";
const BulkAccountVerificationStatus = `Bulk${AccountVerificationStatusTypeName}`;
const chipsMapping = {
  [UserAccountStatusTypeName]: {
    [UserAccountStatus.Active]: {
      label: localizedUserAccountStatus[UserAccountStatus.Active],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Green
    },
    [UserAccountStatus.Locked]: {
      label: localizedUserAccountStatus[UserAccountStatus.Locked],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    },
    [UserAccountStatus.Dormant]: {
      label: localizedUserAccountStatus[UserAccountStatus.Dormant],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    },
    [UserAccountStatus.Blocked]: {
      label: localizedUserAccountStatus[UserAccountStatus.Blocked],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    },
    [UserAccountStatus.Deregistered]: {
      label: localizedUserAccountStatus[UserAccountStatus.Deregistered],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    },
    [UserAccountStatus.Pending]: {
      label: localizedUserAccountStatus[UserAccountStatus.Pending],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Orange
    },
    [UserAccountStatus.Closed]: {
      label: localizedUserAccountStatus[UserAccountStatus.Closed],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    }
  },
  [AmlLabelTypeName]: {
    [AmlLabel.AccountReview]: {
      label: localizedAmlLabel[AmlLabel.AccountReview],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange
    },
    [AmlLabel.ActivityReview]: {
      label: localizedAmlLabel[AmlLabel.ActivityReview],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green
    },
    [AmlLabel.EddDeposit]: {
      label: localizedAmlLabel[AmlLabel.EddDeposit],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightBlue
    },
    [AmlLabel.EddGameplay]: {
      label: localizedAmlLabel[AmlLabel.EddGameplay],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Turquoise
    },
    [AmlLabel.EddPep]: {
      label: localizedAmlLabel[AmlLabel.EddPep],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled
    },
    [AmlLabel.EddWithdrawal]: {
      label: localizedAmlLabel[AmlLabel.EddWithdrawal],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Purple
    },
    [AmlLabel.GameplayReview]: {
      label: localizedAmlLabel[AmlLabel.GameplayReview],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled
    },
    [AmlLabel.VerifyPaymentMethod]: {
      label: localizedAmlLabel[AmlLabel.VerifyPaymentMethod],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled
    }
  },
  [ConnectionTypeTypeName]: {
    [ConnectionType.Mobile]: {
      label: localizedConnectionType[ConnectionType.Mobile],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange
    },
    [ConnectionType.Corporate]: {
      label: localizedConnectionType[ConnectionType.Corporate],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green
    },
    [ConnectionType.VPN]: {
      label: localizedConnectionType[ConnectionType.VPN],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Turquoise
    },
    [ConnectionType.Cloud]: {
      label: localizedConnectionType[ConnectionType.Cloud],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightBlue
    },
    [ConnectionType.Proxy]: {
      label: localizedConnectionType[ConnectionType.Proxy],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Yellow
    },
    [ConnectionType.Residential]: {
      label: localizedConnectionType[ConnectionType.Residential],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Purple
    },
    [ConnectionType.Hosting]: {
      label: localizedConnectionType[ConnectionType.Hosting],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange
    },
    [ConnectionType.Cellular]: {
      label: localizedConnectionType[ConnectionType.Cellular],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green
    },
    [ConnectionType.Business]: {
      label: localizedConnectionType[ConnectionType.Business],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Turquoise
    }
  },
  [AccountVerificationStatusTypeName]: {
    [AccountVerificationStatus.InitLoginKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.InitLoginKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [AccountVerificationStatus.InitWithdrawalKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.InitWithdrawalKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [AccountVerificationStatus.InitDepositKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.InitDepositKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [AccountVerificationStatus.InitPaymentKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.InitPaymentKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [AccountVerificationStatus.OnHoldLoginKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.OnHoldLoginKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange,
      startIconClass: CustomIcon.WarningOutline
    },
    [AccountVerificationStatus.OnHoldWithdrawalKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.OnHoldWithdrawalKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange,
      startIconClass: CustomIcon.WarningOutline
    },
    [AccountVerificationStatus.OnHoldDepositKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.OnHoldDepositKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange,
      startIconClass: CustomIcon.WarningOutline
    },
    [AccountVerificationStatus.OnHoldPaymentKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.OnHoldPaymentKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange,
      startIconClass: CustomIcon.WarningOutline
    },
    [AccountVerificationStatus.Approved]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.Approved],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green,
      startIconClass: CustomIcon.Confirm
    },
    [AccountVerificationStatus.DeniedLoginKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.DeniedLoginKyc],
      chipType: ChipType.TagMark,
      chipVariant: ChipVariant.Default,
      startIconClass: CustomIcon.CancelOutline
    },
    [AccountVerificationStatus.DeniedWithdrawalKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.DeniedWithdrawalKyc],
      chipType: ChipType.TagMark,
      chipVariant: ChipVariant.Default,
      startIconClass: CustomIcon.CancelOutline
    },
    [AccountVerificationStatus.DeniedDepositKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.DeniedDepositKyc],
      chipType: ChipType.TagMark,
      chipVariant: ChipVariant.Default,
      startIconClass: CustomIcon.CancelOutline
    },
    [AccountVerificationStatus.DeniedPaymentKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.DeniedPaymentKyc],
      chipType: ChipType.TagMark,
      chipVariant: ChipVariant.Default,
      startIconClass: CustomIcon.CancelOutline
    },
    [AccountVerificationStatus.InitNdrpKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.InitNdrpKyc],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [AccountVerificationStatus.DeniedNdrpKyc]: {
      label: localizedAccountVerificationStatus[AccountVerificationStatus.DeniedNdrpKyc],
      chipType: ChipType.TagMark,
      chipVariant: ChipVariant.Default,
      startIconClass: CustomIcon.CancelOutline
    }
  },
  [GenderTypeName]: {
    [Gender.Male]: {
      label: localizedGender[Gender.Male],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightBlue
    },
    [Gender.Female]: {
      label: localizedGender[Gender.Female],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Purple
    },
    [Gender.Undefined]: {
      label: localizedGender[Gender.Undefined],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled
    }
  },
  [EnablementModeTypeName]: {
    [EnablementMode.Enabled]: {
      label: localizedSecuritySettings[EnablementMode.Enabled],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Green
    },
    [EnablementMode.Disabled]: {
      label: localizedSecuritySettings[EnablementMode.Disabled],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    },
    [EnablementMode.Null]: {
      label: localizedSecuritySettings[EnablementMode.Null],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    }
  },
  [LoginStatusTypeName]: {
    [LoginStatus.Success]: {
      label: localizedLoginStatus[LoginStatus.Success],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Green
    },
    [LoginStatus.Failed]: {
      label: localizedLoginStatus[LoginStatus.Failed],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    }
  },
  [KycStatusTypeName]: {
    [KycStatus.Successful]: {
      label: localizedKycStatus[KycStatus.Successful],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen,
      startIconClass: CustomIcon.CheckDouble
    },
    [KycStatus.Pending]: {
      label: localizedKycStatus[KycStatus.Pending],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [KycStatus.Failed]: {
      label: localizedKycStatus[KycStatus.Failed],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Bronze,
      startIconClass: CustomIcon.CancelOutline
    },
    [KycStatus.None]: {
      label: localizedKycStatus[KycStatus.None],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    }
  },
  [PlayersRelationTypeTypeName]: {
    [PlayersRelationType.Ip]: {
      label: localizedPlayersRelationType[PlayersRelationType.Ip],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange
    },
    [PlayersRelationType.BankCard]: {
      label: localizedPlayersRelationType[PlayersRelationType.BankCard],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green
    },
    [PlayersRelationType.BankCardName]: {
      label: localizedPlayersRelationType[PlayersRelationType.BankCardName],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightBlue
    },
    [PlayersRelationType.Device]: {
      label: localizedPlayersRelationType[PlayersRelationType.Device],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Turquoise
    },
    [PlayersRelationType.Subnet]: {
      label: localizedPlayersRelationType[PlayersRelationType.Subnet],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Purple
    }
  },
  [UserStatisticsGameTypeTypeName]: {
    [UserStatisticsGameType.Nl]: {
      label: localizedUserStatisticsGameType[UserStatisticsGameType.Nl],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Turquoise
    },
    [UserStatisticsGameType.Sd]: {
      label: localizedUserStatisticsGameType[UserStatisticsGameType.Sd],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange
    },
    [UserStatisticsGameType.Plo]: {
      label: localizedUserStatisticsGameType[UserStatisticsGameType.Plo],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green
    }
  },
  [PaymentOptionTypeName]: {
    [PaymentOption.PaymentOptionCreditcard]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionCreditcard],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionDebitcard]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionDebitcard],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionFastbankttransfer]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionFastbankttransfer],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionNeteller]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionNeteller],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionNone]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionNone],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled
    },
    [PaymentOption.PaymentOptionPaypal]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionPaypal],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionQiwi]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionQiwi],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionYandex]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionYandex],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionSkrill]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionSkrill],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionCryptocurrency]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionCryptocurrency],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionAstropaycard]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionAstropaycard],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionBanklocal]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionBanklocal],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    },
    [PaymentOption.PaymentOptionBankintl]: {
      label: localizedPaymentOption[PaymentOption.PaymentOptionBankintl],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen
    }
  },
  [PaymentVendorTypeName]: {
    [PaymentVendor.Hexopay]: {
      label: PaymentVendor.Hexopay,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green,
      labelTypeString: true
    },
    [PaymentVendor.Nuvei]: {
      label: PaymentVendor.Nuvei,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green,
      labelTypeString: true
    },
    [PaymentVendor.PayPal]: {
      label: PaymentVendor.PayPal,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Green,
      labelTypeString: true
    },
    [PaymentVendor.None]: {
      label: PaymentVendor.None,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      labelTypeString: true
    },
    [PaymentVendor.DevCode]: {
      label: PaymentVendor.DevCode,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      labelTypeString: true
    },
    [PaymentVendor.Intech]: {
      label: PaymentVendor.Intech,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      labelTypeString: true
    },
    [PaymentVendor.OkaysPay]: {
      label: PaymentVendor.OkaysPay,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      labelTypeString: true
    }
  },
  [AccountVerificationTypeTypeName]: {
    [AccountVerificationType.Payment]: {
      label: localizedAccountVerificationType[AccountVerificationType.Payment],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Violet
    },
    [AccountVerificationType.Security]: {
      label: localizedAccountVerificationType[AccountVerificationType.Security],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Purple
    },
    [AccountVerificationType.NdrpVerification]: {
      label: localizedAccountVerificationType[AccountVerificationType.NdrpVerification],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Orange
    }
  },
  [PlayerBonusStatusTypeName]: {
    [PlayerBonusStatus.Active]: {
      label: localizedPlayerBonusStatus[PlayerBonusStatus.Active],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [PlayerBonusStatus.Complete]: {
      label: localizedPlayerBonusStatus[PlayerBonusStatus.Complete],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [PlayerBonusStatus.Expired]: {
      label: localizedPlayerBonusStatus[PlayerBonusStatus.Expired],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    },
    [PlayerBonusStatus.Pending]: {
      label: localizedPlayerBonusStatus[PlayerBonusStatus.Pending],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Disabled,
      startIconClass: CustomIcon.ClockOutline
    }
  },
  [BackpackItemStatusTypeName]: {
    [BackpackItemStatus.Active]: {
      label: localizedBackpackStatus[BackpackItemStatus.Active],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen,
      startIconClass: CustomIcon.Target
    },
    [BackpackItemStatus.Expired]: {
      label: localizedBackpackStatus[BackpackItemStatus.Expired],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGrey
    },
    [BackpackItemStatus.Used]: {
      label: localizedBackpackStatus[BackpackItemStatus.Used],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGrey
    }
  },
  [BulkStatusTypeName]: {
    [BulkStatus.Success]: {
      label: localizedBulkStatus[BulkStatus.Success],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.LightGreen,
      startIconClass: CustomIcon.Confirm
    },
    [BulkStatus.Warning]: {
      label: localizedBulkStatus[BulkStatus.Warning],
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Orange,
      startIconClass: CustomIcon.ErrorCircleOutline
    }
  },
  [FeatureAccessStatusTypeName]: {
    [FeatureAccessStatus.Locked]: {
      label: localizedFeatureAccessStatus[FeatureAccessStatus.Locked],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Disabled
    },
    [FeatureAccessStatus.Unlocked]: {
      label: localizedFeatureAccessStatus[FeatureAccessStatus.Unlocked],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Green
    }
  },
  [TransactionStatusTypeName]: getTransactionStatusChipsMapping(ChipType.Status),
  [NoteTypeTypeName]: getNoteTypeChipsMapping(ChipType.TagMark),
  [WorkspaceTypeName]: getWorkspaceChipsMapping(ChipType.Mark),
  [TransactionTypeTypeName]: getTransactionTypeChipsMapping(ChipType.Mark),
  [TransactionFilterTypeTypeName]: getTransactionFilterTypeChipsMapping(ChipType.Mark),
  [BulkAccountVerificationStatus]: getBulkAccountVerificationStatusChipsMapping(ChipType.Mark),
  TransactionStatusMark: getTransactionStatusChipsMapping(ChipType.Mark),
  [RevenueShareOfferingStatusTypeName]: getRevenueShareOfferingStatusChipsMapping(),
  [GeoCheckStatusTypeName]: getGeoCheckStatusChipsMapping(),
  [GeoCheckEventSourceTypeName]: getGeoCheckEventSourceChipsMapping(),
  [GamePlatformTypeName]: getGamePlatformChipsMapping(),
  [TicketStatusTypeName]: getTicketStatusChipMapping(),
  [TransactionStatusWithReasonTypeName]: getTransactionStatusWithReasonChipConfig(),
  [ChannelTypeName]: getChannelChipsMapping()
};
export {
  BulkAccountVerificationStatus,
  chipsMapping
};
//# sourceMappingURL=chipConfig.js.map
